import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { getPosts } from "../../../store/slices/postsSlice";
import {
  BlogContainer,
  Container,
  ErrorMesg,
  H1,
  Tag1,
  Tag2,
  Tags2,
  Ul,
  UlC,
} from "./styles";
import { getPostCategories } from "../../../store/slices/postCategoriesSlice";
import Footer from "../../../components/layout/Footer/Footer";
import { Post } from "../Post/Post";

const Blog = () => {
  const dispatch: AppDispatch = useDispatch();
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const tagsRef = useRef<HTMLDivElement | null>(null);
  const {
    posts,
    loading: loadingPosts,
    error: errorPosts,
  } = useSelector((state: RootState) => state.posts);

  const {
    postCategories,
    loading: loadingPostCategories,
    error: errorPostCategories,
  } = useSelector((state: RootState) => state.postCategories);

  useEffect(() => {
    dispatch(getPosts());
    dispatch(getPostCategories());
  }, [dispatch]);

  if (loadingPosts || loadingPostCategories) {
    return <div>Loading...</div>;
  }

  if (errorPosts || errorPostCategories) {
    return <div>Error: {errorPosts}</div>;
  }

  const handleCategoryClick = (id: number | null) => {
    setSelectedCategoryId(id);
  };

  return (
    <>
      <BlogContainer>
        <Container>
          <H1>Блог</H1>
          {Array.isArray(postCategories) && postCategories.length > 0 ? (
            <Tags2 ref={tagsRef}>
              <Tag1
                onClick={() => handleCategoryClick(null)}
                isActive={selectedCategoryId === null}
              >
                Все
              </Tag1>
              {postCategories.map((category) => (
                <Tag2
                  key={category.id}
                  onClick={() => handleCategoryClick(category.id)}
                  isActive={selectedCategoryId === category.id}
                >
                  {category.name}
                </Tag2>
              ))}
            </Tags2>
          ) : (
            <ErrorMesg>Таких постов нет</ErrorMesg>
          )}
        </Container>
        {Array.isArray(posts) && posts.length > 0 ? (
          <Ul>
            {posts
              .filter((post) => {
                if (selectedCategoryId === null) return true;

                return post.tags.some((tag) => tag.id === selectedCategoryId);
              })
              .map((post) => {
                return (
                  <Post
                    key={post.id}
                    postImg={post.img}
                    postTitle={post.title}
                    postCreatedAt={post.created_at}
                    postTags={post.tags}
                    postId={post.id}
                  />
                );
              })}
          </Ul>
        ) : (
          <ErrorMesg>Таких постов нет</ErrorMesg>
        )}
      </BlogContainer>
      <Footer />
    </>
  );
};

export default Blog;
